module.exports = __webpack_public_path__ + "img/chat-quote.6225ea4c.svg";